export default __webpack_public_path__ + "static/media/Acolyte's Arm-straps of Balance.49f67de5.jpg";